var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FCEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8356 11.6575C19.0345 11.6575 19.2 11.8226 19.2 12.0327V12.2269C19.2 12.4318 19.0345 12.602 18.8356 12.602H10.3649C10.1655 12.602 10 12.4318 10 12.2269V12.0327C10 11.8226 10.1655 11.6575 10.3649 11.6575H11.8551C12.1578 11.6575 12.4213 11.4423 12.4894 11.1387L12.5674 10.7902C12.6887 10.3154 13.0879 10 13.5447 10H15.6553C16.1072 10 16.5108 10.3154 16.6276 10.7651L16.7111 11.1382C16.7787 11.4423 17.0422 11.6575 17.3454 11.6575H18.8356ZM18.0785 18.7575C18.2341 17.3075 18.5065 13.8626 18.5065 13.8279C18.5164 13.7226 18.4821 13.6229 18.414 13.5427C18.341 13.4675 18.2485 13.4231 18.1466 13.4231H11.0572C10.9548 13.4231 10.8574 13.4675 10.7898 13.5427C10.7212 13.6229 10.6874 13.7226 10.6924 13.8279C10.6933 13.8342 10.703 13.9556 10.7194 14.1585C10.792 15.0597 10.9942 17.5697 11.1248 18.7575C11.2173 19.6325 11.7914 20.1824 12.623 20.2024C13.2648 20.2172 13.9259 20.2223 14.6019 20.2223C15.2387 20.2223 15.8854 20.2172 16.547 20.2024C17.4074 20.1876 17.9811 19.6473 18.0785 18.7575Z",
    fill: "#ED1B2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon);
export default __webpack_public_path__ + "static/media/delete icon.7d802d8b8998c953a093cc36d127cb99.svg";
export { ForwardRef as ReactComponent };